import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { handleError } from "../../../../../utils/ErrorHandler";

const initialState = {
	list: [],
	booking: null,
	error: "",
	isFetchingAll: false,
	isSubmitting: false,
};

// Get all bookings
export const getAllBookings = createAsyncThunk(
	"booking/getAllBookings",
	async (_, { rejectWithValue }) => {
		try {
			const { data } = await axios.get("/slot-booking?query=all");
			return data.bookings;
		} catch (error) {
			const errorMessage = handleError(error, "Failed to fetch all bookings");
			return rejectWithValue(errorMessage);
		}
	}
);

// Add booking
export const addBooking = createAsyncThunk(
	"booking/addBooking",
	async (values, { rejectWithValue }) => {
		try {
			const { data } = await axios.post("slot-booking", values);
			toast.success("Booking added successfully!");
			return data;
		} catch (error) {
			const errorMessage = handleError(error, "Failed to add booking");
			return rejectWithValue(errorMessage);
		}
	}
);

const bookingSlice = createSlice({
	name: "booking",
	initialState,
	reducers: {
		clearBooking: (state) => {
			state.booking = null;
		},
	},
	extraReducers: (builder) => {
		// getAllBookings
		builder.addCase(getAllBookings.pending, (state) => {
			state.isFetchingAll = true;
			state.error = "";
		});
		builder.addCase(getAllBookings.fulfilled, (state, action) => {
			state.isFetchingAll = false;
			state.list = action.payload;
		});
		builder.addCase(getAllBookings.rejected, (state, action) => {
			state.isFetchingAll = false;
			state.error = action.payload;
		});

		// addBooking
		builder.addCase(addBooking.pending, (state) => {
			state.isSubmitting = true;
			state.error = "";
		});
		builder.addCase(addBooking.fulfilled, (state, action) => {
			state.isSubmitting = false;
			state.list.push(action.payload);
		});
		builder.addCase(addBooking.rejected, (state, action) => {
			state.isSubmitting = false;
			state.error = action.payload;
		});
	},
});

export default bookingSlice.reducer;
export const { clearBooking } = bookingSlice.actions;
